import { type BundleConfigOption, type StockStatusElements } from "@jti/fe-common";

export const getBundleOptions = (options: BundleConfigOption[], optionsStock?: StockStatusElements) =>
  optionsStock ? options.filter((data: BundleConfigOption) => data.id) : [];
